import { LoadableUserSettingsNav, metaOSUserSettingsRoutesForLeftNav } from '@ms/yammer-user-settings-page';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { DefaultLeftNav } from './DefaultLeftNav';

export const AppLeftNav: React.FC = () => (
  <Switch>
    <Route exact={true} strict={false} path={metaOSUserSettingsRoutesForLeftNav}>
      <LoadableUserSettingsNav withAppName={true} />
    </Route>
    <Route>
      <DefaultLeftNav />
    </Route>
  </Switch>
);
